{
  "es": {
    "models": {
      "name": "Naves",
      "model": {
        "metrics": {
          "base": "Base",
          "crew": "Tripulación",
          "info": "Info",
          "levels": "Niveles",
          "speed": "Velocidad"
        },
        "focus": "Enfoque",
        "classification": "Clasificación",
        "size": "Tamaño",
        "beam": "Manga",
        "cargo": "Carga",
        "crew": "Tripulación",
        "speed": "Velocidad",
        "scmSpeed": "SCM Speed",
        "maxSpeed": "Velocidad máx.",
        "scm": "SCM",
        "max": "Máx",
        "groundMaxSpeed": "Velocidad máx.",
        "groundReverseSpeed": "Velocidad de reversa",
        "pitch": "Pitch",
        "yaw": "Yaw",
        "roll": "Roll",
        "price": "Precio",
        "groundAcceleration": "Aceleración",
        "groundDeceleration": "Deceleración",
        "scmSpeedAcceleration": "Cero a SCM",
        "scmSpeedDeceleration": "SCM a Cero",
        "compare": {
          "groundMaxSpeed": "Velocidad terrestre máx.",
          "groundReverseSpeed": "Velocidad terrestre de reversa",
          "groundAcceleration": "Aceleración terrestre",
          "groundDeceleration": "Deceleración terrestre"
        },
        "quantumFuelTankSize": "Combustible Quantum",
        "hydrogenFuelTankSize": "Combustible",
        "pledgePrice": "Precio de Pledge",
        "height": "Altura",
        "length": "Longitud",
        "mass": "Masa",
        "manufacturer": "Fabricante",
        "hardpoints": "Puntos de montaje",
        "weapons": "Armas",
        "equipment": "Equipamiento",
        "variants": "Variantes",
        "productionStatus": "Estado de producción",
        "propulsion": "Propulsión",
        "modular": "Modular",
        "soldAt": "¿Vendido en?",
        "rentalAt": "¿Alquilado en?",
        "lastUpdatedAt": "¿Última actualización?",
        "loaners": "Prestados",
        "paints": "Pinturas",
        "modules": "Módulos",
        "modulePackages": "Paquetes de módulos",
        "upgrades": "Kits de mejora",
        "brochure": "Folleto",
        "onSale": "En venta",
        "salesPage": "Página de venta",
        "addons": "Módulos y kits de mejora",
        "productionStatuses": {
          "notAvailable": "N/A",
          "ready": "Listo para hangar",
          "announced": "Anunciado"
        }
      }
    }
  }
}
